import { render, staticRenderFns } from "./EscalaModeloMenu.vue?vue&type=template&id=19474d85&"
import script from "./EscalaModeloMenu.vue?vue&type=script&lang=js&"
export * from "./EscalaModeloMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports